/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as manipulações de setores
 * @author Bene Lemuel Dantas Gondim
 * @file orgao.setorReducer.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */
import types from 'utils/actionTypes'

// Estado inicial da sessão no redux
const initialState = {
  setores: [],
  error: null,
  nomeFuncao: '',
  dados: {
    id: '',
    nome: '',
    sigla: '',
    descricao: '',
    divisao: '',
  },
  necroterios: null,
}

const setoresReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SETORES_DIVISAO: {
      return {
        ...state,
        setores: action.setores,
      }
    }

    case types.SET_NECROTERIOS: {
      return {
        ...state,
        necroterios: action.necroterios,
      }
    }
    default: {
      return state
    }
  }
}

export default setoresReducer
